import React from "react";
import {
  FaYoutube,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaExternalLinkAlt,
} from "react-icons/fa";

export default function SocialLinks() {
  const socialLinks = [
    {
      name: "YouTube",
      icon: <FaYoutube size={45} color="#FF0000" />,
      description: "Watch tutorials, seminars, campus events and placement sessions.",
      followers: "25K+ Subscribers",
      url: "https://youtube.com",
      color: "#FF0000",
    },
    {
      name: "Facebook",
      icon: <FaFacebookF size={45} color="#1877F2" />,
      description: "Latest announcements, events and student activities.",
      followers: "18K+ Followers",
      url: "https://facebook.com",
      color: "#1877F2",
    },
    {
      name: "Instagram",
      icon: <FaInstagram size={45} color="#E4405F" />,
      description: "Campus life, achievements and memorable moments.",
      followers: "30K+ Followers",
      url: "https://instagram.com",
      color: "#E4405F",
    },
    {
      name: "LinkedIn",
      icon: <FaLinkedinIn size={45} color="#0A66C2" />,
      description: "Placement updates, alumni network and career opportunities.",
      followers: "12K+ Followers",
      url: "https://linkedin.com",
      color: "#0A66C2",
    },
    {
      name: "Twitter (X)",
      icon: <FaTwitter size={45} color="#1DA1F2" />,
      description: "Instant news, notices and institute updates.",
      followers: "9K+ Followers",
      url: "https://twitter.com",
      color: "#1DA1F2",
    },
  ];

  return (
    <section
      style={{
        padding: "80px 8%",
        background: "#f8fafc",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginBottom: "60px",
        }}
      >
        <h1
          style={{
            fontSize: "42px",
            color: "#0f172a",
          }}
        >
          Connect With Us
        </h1>

        <p
          style={{
            maxWidth: "720px",
            margin: "20px auto",
            color: "#64748b",
            lineHeight: "30px",
          }}
        >
          Stay connected through our official social media platforms for
          announcements, campus news, placement updates, achievements and
          educational content.
        </p>
      </div>

      {/* Social Cards */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
          gap: "30px",
        }}
      >
        {socialLinks.map((item, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              borderRadius: "20px",
              padding: "30px",
              boxShadow: "0 10px 25px rgba(0,0,0,.08)",
              transition: ".3s",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: `${item.color}15`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
              }}
            >
              {item.icon}
            </div>

            <h2
              style={{
                color: "#0f172a",
              }}
            >
              {item.name}
            </h2>

            <p
              style={{
                marginTop: "15px",
                color: "#64748b",
                lineHeight: "28px",
              }}
            >
              {item.description}
            </p>

            <h4
              style={{
                marginTop: "20px",
                color: item.color,
              }}
            >
              {item.followers}
            </h4>

            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                marginTop: "25px",
                padding: "12px 22px",
                background: item.color,
                color: "#fff",
                textDecoration: "none",
                borderRadius: "10px",
                fontWeight: "bold",
              }}
            >
              Follow <FaExternalLinkAlt size={13} />
            </a>
          </div>
        ))}
      </div>

      {/* Statistics */}

      <div
        style={{
          marginTop: "80px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
          gap: "20px",
        }}
      >
        {[
          {
            title: "Total Followers",
            value: "94K+",
          },
          {
            title: "Monthly Reach",
            value: "250K+",
          },
          {
            title: "Videos Published",
            value: "500+",
          },
          {
            title: "Events Covered",
            value: "150+",
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              padding: "30px",
              textAlign: "center",
              borderRadius: "18px",
              boxShadow: "0 8px 20px rgba(0,0,0,.08)",
            }}
          >
            <h3>{item.title}</h3>

            <h1
              style={{
                marginTop: "15px",
                color: "#0284c7",
              }}
            >
              {item.value}
            </h1>
          </div>
        ))}
      </div>

      {/* Bottom Banner */}

      <div
        style={{
          marginTop: "70px",
          background: "linear-gradient(135deg,#0284c7,#16a34a)",
          borderRadius: "20px",
          padding: "50px",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <h2>Join Our Online Community</h2>

        <p
          style={{
            maxWidth: "700px",
            margin: "20px auto",
            lineHeight: "30px",
          }}
        >
          Follow us to receive instant notifications about admissions,
          placements, workshops, webinars, examination updates, campus
          activities and student achievements.
        </p>
      </div>
    </section>
  );
}